import { h, Component } from 'preact';

export default class HeaderView extends Component {
    render() {
        return (
            <header>
                <div class="print-only">
                    <img src="./assets/logos/noaa-badge-color-56px.svg" class="print-logo" alt="NOAA Office for Coastal Management logo" />
                    <span class="print-header-container">
                        <h1 class="print-header">OFFICE FOR COASTAL MANAGEMENT</h1>
                        <h2 class="print-subheader">coast.noaa.gov</h2>
                    </span>
                </div>
                <div class="flex-container--row contain-width no-print">
                    <div class="brand flex-col-6">
                        <a href="./" title="Return Home" class="brand-link" data-ga="Branding">
                            <span class="brand-badge">
                                <img src="https://coast.noaa.gov/data/coasthome/img/50ocmlogo.png" alt="Office for Coastal Management" />
                            </span>
                            <span class="brand-badge-mobile">
                            </span>
                        </a>
                    </div>
                    <div class="flex-col-6 container-nav-elements">
                        <button class="nav-toggle-button js-search" role="button">
                            <img src="//coast.noaa.gov/img/search-icon.png" class="icon-mobile icon-search" alt="Search Icon" />
                            <span class="hidden-508">Mobile Search Toggle</span>
                        </button>
                        <form class="form-search toggle-object" action="//search.usa.gov/search" method="get">
                            <input name="affiliate" value="ocm_search" type="hidden" />
                            <label for="query" class="hidden-508">Type Search Terms in the Form Field</label>
                            <input type="text" class="form-search--input" tabindex="1" name="query" id="query" placeholder="Search" />
                            <button type="submit" name="submit" class="form-search--submit" value="submit">
                                <i class="ion-search"></i>
                                <span class="hidden-508">Submit</span>
                            </button>
                        </form>
                        <button class="nav-toggle-button js-nav" role="button">
                            <img src="//coast.noaa.gov/img/nav-icon.png" class="icon-mobile icon-nav" alt="Menu Icon" />
                            <span class="hidden-508">Mobile Navigation Toggle</span>
                        </button>
                        <nav class="toggle-object js-nav">
                            <ul class="nav-list">
                                <li><a href="/">Home</a></li>
                                <li class="dropdown"><a class="dropdown-toggle" data-toggle="dropdown" href="#">About<span class="caret"></span></a>
                                    <ul class="dropdown-menu">
                                        <li><a href="/about/">About the Office</a></li>
                                        <li><a href="/about/directions/">Directions</a></li>
                                        <li><a href="/about/employment/">Employment</a></li>
                                        <li><a href="/about/organization/">Organization Chart</a></li>
                                        <li><a href="/about/staff/">Staff Directory</a></li>
                                    </ul>
                                </li>
                                <li class="dropdown">
                                    <a class="dropdown-toggle" data-toggle="dropdown" id="stateselect">State
                                        Programs<span class="caret"></span>
                                    </a>
                                    <ul class="dropdown-menu dropdown-states js-list" id="list">
                                        <span id="searchbox">
                                            <form class="states-filter-form" action="#">
                                                <label class="hidden-508" for="stateFilter">Type a state name to filter the list</label>
                                                <input class="filterinput input-block-level states-filter" type="text" placeholder="Type a State or Territory" name="stateFilter" id="stateFilter" />
                                            </form>
                                        </span>
                                        <div class="dropdown-scroll">
                                            <li><a href="/states/alabama.html">Alabama</a></li>
                                            <li><a href="/states/alaska.html">Alaska</a></li>
                                            <li><a href="/states/american-samoa.html">American Samoa</a></li>
                                            <li><a href="/states/california.html">California</a></li>
                                            <li><a href="/states/connecticut.html">Connecticut</a></li>
                                            <li><a href="/states/cnmi.html">Commonwealth of the Northern Mariana Islands</a></li>
                                            <li><a href="/states/delaware.html">Delaware</a></li>
                                            <li><a href="/states/florida.html">Florida</a></li>
                                            <li><a href="/states/georgia.html">Georgia</a></li>
                                            <li><a href="/states/guam.html">Guam</a></li>
                                            <li><a href="/states/hawaii.html">Hawaii</a></li>
                                            <li><a href="/states/illinois.html">Illinois</a></li>
                                            <li><a href="/states/indiana.html">Indiana</a></li>
                                            <li><a href="/states/louisiana.html">Louisiana</a></li>
                                            <li><a href="/states/maine.html">Maine</a></li>
                                            <li><a href="/states/maryland.html">Maryland</a></li>
                                            <li><a href="/states/massachusetts.html">Massachusetts</a></li>
                                            <li><a href="/states/michigan.html">Michigan</a></li>
                                            <li><a href="/states/minnesota.html">Minnesota</a></li>
                                            <li><a href="/states/mississippi.html">Mississippi</a></li>
                                            <li><a href="/states/new-hampshire.html">New Hampshire</a></li>
                                            <li><a href="/states/new-jersey.html">New Jersey</a></li>
                                            <li><a href="/states/new-york.html">New York</a></li>
                                            <li><a href="/states/north-carolina.html">North Carolina</a></li>
                                            <li><a href="/states/ohio.html">Ohio</a></li>
                                            <li><a href="/states/oregon.html">Oregon</a></li>
                                            <li><a href="/states/pennsylvania.html">Pennsylvania</a></li>
                                            <li><a href="/states/puerto-rico.html">Puerto Rico</a></li>
                                            <li><a href="/states/rhode-island.html">Rhode Island</a></li>
                                            <li><a href="/states/south-carolina.html">South Carolina</a></li>
                                            <li><a href="/states/texas.html">Texas</a></li>
                                            <li><a href="/states/usvi.html">U.S. Virgin Islands</a></li>
                                            <li><a href="/states/virginia.html">Virginia</a></li>
                                            <li><a href="/states/washington.html">Washington</a></li>
                                            <li><a href="/states/wisconsin.html">Wisconsin</a></li>
                                        </div>
                                    </ul>
                                </li>
                                <li class="dropdown">
                                    <a class="dropdown-toggle" data-toggle="dropdown" href="#">National
                                        Programs<span class="caret"></span>
                                    </a>
                                    <ul class="dropdown-menu">
                                        <li><a href="/czm/" title="">Coastal Zone Management</a></li>
                                        <li><a href="http://coralreef.noaa.gov/" title="">Coral Reef Conservation</a></li>
                                        <li><a href="//coast.noaa.gov/digitalcoast/" title="">Digital Coast</a></li>
                                        <li><a href="//coast.noaa.gov/nerrs" title="">National Estuarine Research Reserves</a>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
                <a href="#main" title="Skip Main Navigation" class="hidden-508" accesskey="1">Skip Main Navigation</a>
            </header>
        );
    }
}
